import React, { useMemo } from 'react';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useLocale } from '@/common/hooks/index';
import { ReactBB } from '@/common/utils/bbParser/index';
import InfoIcon from '@mui/icons-material/Info';
import { useGeneralMetaDataQuery } from '@/entities/meta-data';

const LightTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#666666',
    boxShadow: theme.shadows[1],
    fontSize: '16px',
    lineHeight: '24px',
    padding: '8px 16px',
    fontWeight: '400',
    textAlign: 'left',
    maxHeight: 'calc(100vh - 32px)',
    overflowY: 'auto',
  },
}));

const Tooltip = ({ children, ...props }) => {
  const { data: metaData = {} } = useGeneralMetaDataQuery();
  const { tooltips = {} } = metaData;
  const { isFr } = useLocale();
  const tip = useMemo(() => {
    const value = Object.keys(props).find((key) => key.includes('tip'));
    const content =
      (isFr ? tooltips[value]?.contentFr : tooltips[value]?.content) ??
      tooltips[value]?.content ??
      '';

    return ReactBB(content);
  }, [isFr, props, tooltips]);

  return (
    <LightTooltip title={tip} placement="left">
      {children ? (
        <span className="successText">{children}</span>
      ) : (
        <InfoIcon className={'MuiButton-outlinedSecondary'} />
      )}
    </LightTooltip>
  );
};

export default Tooltip;
